import TechnicianIndexVue from "@/views/technician/TechnicianIndex.vue";

const technician = [
  {
    path: "/technician",
    name: "technician",
    component: TechnicianIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
];

export default technician;
